import { render, staticRenderFns } from "./ModalRotacione.vue?vue&type=template&id=61a3244e&"
import script from "./ModalRotacione.vue?vue&type=script&lang=js&"
export * from "./ModalRotacione.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports